import { Component, EventEmitter, Input, Output } from '@angular/core';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'critical' | 'activity';
export type BadgeSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'fi-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  standalone: false,
})
export class BadgeComponent {
  @Input() tone: BadgeTone = 'neutral';
  @Input() size: BadgeSize = 'md';
  @Input() iconBefore?: string;
  @Input() dismissible = false;
  @Input() disabled = false;

  @Output() dismissed = new EventEmitter<void>();

  onDismiss(): void {
    if (this.disabled) {
      return;
    }
    this.dismissed.emit();
  }
}
